import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { User } from '../models/user';
import { environment } from '../../environments/environment';
import { IAccountActivationToken } from '../_interfaces/activationToken';
import { UserAdminView } from '../models/user-admin-view';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  baseUrl: string = environment.apiUrl;

  constructor(private HttpClient: HttpClient) {}

  addUser(user : User): Observable<User> {
    return this.HttpClient.post<User>(
      this.baseUrl + '/users',
      user
    );
  }

  register(user : User): Observable<User> {
    return this.HttpClient.post<User>(
      this.baseUrl + '/auth/register',
      user
    );
  }

  activateAccount(token : IAccountActivationToken): Observable<string> {
    return this.HttpClient.get<string>(
      this.baseUrl + '/auth/activate/'+token.activation_token,
      
    );
  }

  getCurrentUser(): Observable<User> {
    return this.HttpClient.get<User>(this.baseUrl + '/users/me');
  }

  updateCurrentUser(user: User): Observable<User> {
    return this.HttpClient.put<User>(this.baseUrl + '/users/me', user);
  }

  getUsersForAdmin(): Observable<UserAdminView[]> {
    return this.HttpClient.get<UserAdminView[]>(this.baseUrl + '/users');
  }
}
